import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonLoading
} from '@ionic/react'
import { arrowBack, refresh } from 'ionicons/icons'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import ActionSheet from '../../components/ActionSheet'
import AddButton from '../../components/AddButton'
import NoData from '../../components/NoData'
import ViewData from '../../components/ViewData'
import { useAppContext } from '../../context/AppContext'
import useMessages from '../../hooks/useMessages'
import { saveProspectos, storeProcedureDetail } from '../../redux/actions'
import { getReferidos } from '../../services/api/porta-estado/index'

const Prospectos = () => {
  const history = useHistory()
  const [showActionSheet, setShowActionSheet] = useState(false)
  const [prospectos, setProspectos]: any = useState([])
  const [present, dismiss] = useIonLoading()
  const dispatch = useDispatch()
  const [prospecto, setProspecto]: any = useState({})
  const { user, settings, blockNavigation }: any = useAppContext()
  const { toastMessage } = useMessages()

  const loadData = async () => {
    present({
      message: `Cargando referidos. <br/> Esperá por favor.`
    })
    try {
      const prospectosResponse = await getReferidos(user, settings.country)
      dispatch(saveProspectos(prospectosResponse))
      setProspectos(prospectosResponse)
      dismiss()
    } catch (error: any) {
      dismiss()
      toastMessage('No se pudieron obtener los referidos.', 3000, 'bottom', 'error')
    }
  }

  const viewProspectoDetail = (prospectoSelected: any) => {
    dispatch(storeProcedureDetail(prospectoSelected))
    setProspecto(prospectoSelected)
  }

  useEffect(() => {
    if (!blockNavigation) loadData()
  }, [blockNavigation])

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={(e) => history.push('/procedures')}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{settings.procedures.referred.title}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={loadData}>
              <IonIcon icon={refresh} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <AddButton id="nuevo-referido" href="/procedures/referidos/nuevo-referido" blockNavigation />
        <ActionSheet
          data={prospecto.id}
          procedure="prospectos"
          showActionSheet={showActionSheet}
          setShowActionSheet={setShowActionSheet}
        />
        {Array.isArray(prospectos) && prospectos.length ? (
          <ViewData
            procedure="prospectos"
            data={prospectos}
            setShowActionSheet={setShowActionSheet}
            setData={viewProspectoDetail}
          />
        ) : (
          <NoData type="empty" />
        )}
      </IonContent>
    </IonPage>
  )
}

export default Prospectos
